<template>
  <div>
    <p>广告预览</p>
    <!-- DPA 目录广告模式预览 -->
    <div v-if="isDpaMode" class="dpa-preview">
      <el-select v-model="dpaAdFormat" placeholder="选择预览格式" size="small" style="margin-bottom: 12px; width: 240px;" @change="dpaPreviewDebounced">
        <el-option label="手机动态消息" value="MOBILE_FEED_STANDARD" />
        <el-option label="桌面动态消息" value="DESKTOP_FEED_STANDARD" />
        <el-option label="Instagram 动态" value="INSTAGRAM_STANDARD" />
        <el-option label="Instagram 快拍" value="INSTAGRAM_STORY" />
      </el-select>
      <div v-if="dpaPreviewLoading" v-loading="true" style="min-height: 200px;"></div>
      <div v-else-if="dpaPreviewHtml" v-html="dpaPreviewHtml" ref="dpaPreviewFrame"></div>
      <div v-else class="dpa-preview-placeholder">
        <p style="color: #999; font-size: 13px; text-align: center; padding: 40px 0;">
          {{ dpaPreviewMsg || '填写模板信息后自动生成预览' }}
        </p>
      </div>
    </div>
    <!-- 普通广告预览 -->
    <!-- {{ currentCreative }} -->
    <el-select v-model="ad_format" placeholder="请选择" v-if="initData.placement && !isDpaMode">
      <el-option-group v-for="group in initData.placement.PublisherPlatform" :key="group.key" :label="group.desc">
        <el-option v-for="(item, index) in group.positions.filter((v) => v.adFormat)" :key="item.value" :label="item.desc"
          :value="item.adFormat.key + '&' + index">
        </el-option>
      </el-option-group>
    </el-select>
    <div class="iframe" id="iframe" ref="previewFrame" v-loading="previewLoading" v-if="creativeList.length && !isDpaMode">
      <div class="listBtn">
        <el-button icon="el-icon-arrow-left" type="text" :disabled="index == 0" @click="index-=1"></el-button>
        <span><span class="">{{index + 1}}</span>/ {{ creativeList.length}}</span>
        <el-button icon="el-icon-arrow-right" type="text" :disabled="index == creativeList.length-1"  @click="index+=1"></el-button>
      </div>
      <div v-html="iframeList[index]"></div>
      <!-- 模式A：广告层级关联目录时提示 -->
      <div v-if="isCatalogModeA && currentCreative.associated_product_set_id" class="catalog-mode-a-tip">
        <i class="el-icon-goods" style="margin-right: 4px;"></i>
        已关联商品目录，投放后广告底部将展示"浏览更多商品"推荐
      </div>
    </div>
  </div>
</template>
<script>
import {
  preview,
  dpaPreview,
} from '@/api/creatAd.js';
import tools from '../tools'
import adsMethods from '../../adsMethods'
let _ = require('lodash');
export default {
  mixins: [tools, adsMethods],
  props: {
    initData: {
      type: Object,
      default: () => { }
    },
    accountId: {
      type: String,
      default: 0,
    },
    adSeriesInfo: {
      type: Object,
      default: () => {
        return { siteUrl: null };
      },
    },
    campaign_objective: {
      type: String,
      default: 'OUTCOME_SALES', //转化量
    },
    rowThirdNum: {
      type: String,
      default: '',
    },
    currentCreative: {
      type: Object,
      default: () => { }
    },
    isFbPageAd:{
      type: Boolean,
      default: false,
    },
    edit:{
      type: Boolean,
      default: false,
    },
    previewIndex:{
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      ad_format: 'MOBILE_FEED_STANDARD&0',
      previewLoading: false,
      iframeList: [],
      index: 0,
      // DPA 预览相关
      dpaAdFormat: 'MOBILE_FEED_STANDARD',
      dpaPreviewLoading: false,
      dpaPreviewHtml: '',
      dpaPreviewMsg: '',
    }
  },
  computed: {
    isDpaMode() {
      return this.adSeriesInfo && this.adSeriesInfo.isDpaEnabled && this.adSeriesInfo.isAdvancedCatalog;
    },
    isCatalogModeA() {
      // 创建模式：通过 adSeriesInfo 开关判断
      if (this.adSeriesInfo && this.adSeriesInfo.isDpaEnabled && !this.adSeriesInfo.isAdvancedCatalog) {
        return true;
      }
      // 编辑模式：通过广告数据本身判断（有 associated_product_set_id 且不是 DPA 模式）
      if (this.edit && this.currentCreative && this.currentCreative.associated_product_set_id && !this.isDpaMode) {
        return true;
      }
      return false;
    },
    media_type() {
      return this.currentCreative.media_type
    },
    creativeList(){
      if (this.edit || this.isFbPageAd || (this.media_type == 'muti' || this.media_type == 'post' || this.media_type == 'asset_feed')) {
        return [this.currentCreative]
      }else{
        return this.setCreative()
      }
    },
    creative() {
      return this.creativeList[this.index] || {}
    }
  },
  watch: {
    creative: {
      handler(newV, old) {
        console.log(newV, old,'creative');
        if (!this.isDpaMode) {
          this.debouncedPreviewIframe(this.index)
        }
      },
      deep: true,
      immediate: true
    },
    // DPA 模式下监听 templateData 变化触发预览
    'currentCreative.templateData': {
      handler() {
        if (this.isDpaMode) {
          this.dpaPreviewDebounced();
        }
      },
      deep: true,
    },
    previewIndex:{
      handler() {
        this.index = this.previewIndex;
      }
    }
  },
  created(){
    this.debouncedPreviewIframe = _.debounce(this.previewIframe, 1500);
    this.dpaPreviewDebounced = _.debounce(this.fetchDpaPreview, 2000);
  },
  methods: {
    // DPA 预览：调 FB generatePreviews 接口
    fetchDpaPreview() {
      const templateData = this.currentCreative?.templateData;
      if (!templateData || !templateData.link || !this.currentCreative.page_id) {
        this.dpaPreviewHtml = '';
        this.dpaPreviewMsg = '请填写网址并选择主页后自动生成预览';
        return;
      }
      // 需要 productSetId（从 adSeriesInfo 中获取，DPA 模式下在 audience 层级选择）
      // 暂时用 adSeriesInfo.productCatalogId 作为 catalogId
      const catalogId = this.adSeriesInfo?.productCatalogId;
      if (!catalogId) {
        this.dpaPreviewHtml = '';
        this.dpaPreviewMsg = '请先选择商品目录';
        return;
      }
      this.dpaPreviewLoading = true;
      this.dpaPreviewMsg = '';
      dpaPreview({
        accountId: this.accountId,
        catalogId: catalogId,
        adFormat: this.dpaAdFormat,
        pageId: this.currentCreative.page_id,
        templateData: { ...templateData, forceSingleLink: templateData.formatType === 'single' },
      }).then((res) => {
        if (res.code === 0 && res.data) {
          this.dpaPreviewHtml = res.data;
          this.$nextTick(() => {
            if (this.$refs.dpaPreviewFrame?.getElementsByTagName('iframe')[0]) {
              this.$refs.dpaPreviewFrame.getElementsByTagName('iframe')[0].width = '100%';
            }
          });
        } else {
          this.dpaPreviewHtml = '';
          this.dpaPreviewMsg = res.msg || '预览生成失败';
        }
      }).catch(() => {
        this.dpaPreviewHtml = '';
        this.dpaPreviewMsg = '预览请求失败，请稍后重试';
      }).finally(() => {
        this.dpaPreviewLoading = false;
      });
    },
    setCreative(){
      let imgList = this.currentCreative.imgList || [];
      let creative = JSON.parse(JSON.stringify(this.currentCreative));
      delete creative.imgList;
      
      let list = [];
      imgList.forEach(item=>{
        // 同步 title 数组（与 message 处理方式一致，传递完整数组）
        let titleVal = item.title;
        if (!titleVal || (Array.isArray(titleVal) && !titleVal.some((t) => t && t.trim()))) {
          titleVal = this.defaultTitle(imgList);
        }
        let contentVal = item.content;
        if (!contentVal || (Array.isArray(contentVal) && !contentVal.some((c) => c && c.trim()))) {
          contentVal = this.defaultContent(imgList);
        }
        let messageVal = item.message || this.defaultMessage(imgList);
        // 兼容旧逻辑：确保 copywriter 对象存在
        let copywriter = item.copywriter || { title: '', content: '' };
        list.push({...creative, image: item.url, source_id: item.id, mediaSourceType: item.sourceType || item.mediaSourceType, thumbUrl: item.thumbUrl, title: titleVal, content: contentVal, message: messageVal, copywriter: copywriter, videoStatus: item.videoStatus})
      })
      return list
    },
    previewIframe(index) {
      let creative = JSON.parse(JSON.stringify(this.creative));
      creative.mediaSourceType = creative.sourceType || creative.mediaSourceType;
      delete creative.sourceType;
      const validCreativeObj = this.validCreative(creative, this.adSeriesInfo);
      // console.log(validCreativeObj,'validCreativeObj');
      
      if (validCreativeObj.flag) {
        let ad_format = this.ad_format.split('&')[0];
        // 构建 copywriter 参数：确保 title/content 为字符串格式（后端 Copywriter 字段为 String）
        const copywriterParams = {};
        if (creative.copywriter) {
          const cw = creative.copywriter;
          copywriterParams.title = Array.isArray(cw.title) ? (cw.title.find((t) => t && t.trim()) || '') : (cw.title || '');
          copywriterParams.content = Array.isArray(cw.content) ? (cw.content.find((c) => c && c.trim()) || '') : (cw.content || '');
        }
        let params = {
          account_id: this.accountId,
          ad_format: ad_format,
          objective: this.adSeriesInfo.objective || this.campaign_objective,
          creative: validCreativeObj.creative,
          ...copywriterParams,
        };
        this.previewLoading = true;
        preview(params).then((res) => {
          this.$set(this.iframeList, index, res.data);
          this.$nextTick(() => {
            if (this.$refs.previewFrame?.getElementsByTagName('iframe')[0]) {
              this.$refs.previewFrame.getElementsByTagName('iframe')[0].width = '100%';
            }
          });
        }).catch(() => {
          // 预览请求失败，静默处理
        }).finally(() => {
          this.previewLoading = false;
        });
      }
    },

  }
}
</script>
<style lang="scss" scoped>
  .listBtn{
    font-size: 14px;
    color: #666;
  }
  .dpa-preview {
    margin-top: 12px;
    .dpa-preview-placeholder {
      border: 1px dashed #d9d9d9;
      border-radius: 8px;
      background: #fafafa;
      min-height: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .catalog-mode-a-tip {
    margin-top: 10px;
    padding: 8px 12px;
    background: #f0f9eb;
    border: 1px solid #e1f3d8;
    border-radius: 4px;
    color: #67c23a;
    font-size: 12px;
    line-height: 1.5;
  }
</style>